import { Chip, Skeleton, Stack, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';
import { ResultStatus } from '@dispatch/shared/types';
import { TabContainerProps } from '../../tab-component/TabContainer';

/**
 *	StandardTabLayout utilizes the standard layout header with tab abilities.
 */
export const StandardTabLayout = ({
  title,
  subtitle,
  showIsActive,
  isActive,
  renderMeta,
  status,
  metas,
  renderTabs,
}: {
  title?: string;
  subtitle?: string;
  showIsActive?: boolean;
  isActive?: boolean;
  renderMeta?: () => React.ReactNode[] | undefined;
  status?: ResultStatus;
  metas?: React.ReactNode[];
  renderTabs?: React.ReactElement<TabContainerProps>;
}) => {
  return (
    <Stack>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignContent="center"
        alignItems="center"
        padding={'32px 24px'}
      >
        <Stack spacing={0.5} justifyContent="center">
          <Typography
            data-testid="drawer-title"
            variant="h1"
            sx={{
              margin: 0,
              fontSize: '1.2em',
              fontWeight: '400',
            }}
          >
            {status === 'loading' ? (
              <Skeleton width="10em" height="2em" sx={{ margin: 0 }} />
            ) : (
              title
            )}
          </Typography>
          {subtitle && (
            <Typography
              data-testid="drawer-subtitle"
              variant="h2"
              sx={{
                margin: 0,
                fontFamily: "'Roboto', sans-serif",
                fontSize: '0.75em',
                fontWeight: '500',
                color: '#cccff8',
                textTransform: 'uppercase',
              }}
            >
              {status === 'loading' ? (
                <Skeleton width="5em" height="2em" sx={{ margin: 0 }} />
              ) : (
                subtitle
              )}
            </Typography>
          )}
        </Stack>
        <Stack direction="row" spacing={4} data-testid="drawer-meta">
          {metas && renderMeta && renderMeta()}
          {showIsActive && status !== 'loading' && (
            <Chip
              data-testid="drawer-active"
              label={isActive ? 'Active' : 'Inactive'}
              sx={{
                minWidth: '5em',
                fontSize: '.85em',
                color: '#FFFFFF',
                backgroundColor: isActive ? '#4CAF50' : '#F44336',
              }}
            />
          )}
        </Stack>
      </Stack>
      <Box>{renderTabs}</Box>
    </Stack>
  );
};
